import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/view/Home'
const Product = () => import('@/view/Product')
const ProductDetail = () => import('@/view/ProductDetail')

import Plan from '@/view/Plan'
import SuccessCases from '@/view/SuccessCases'
import Hardware from '@/view/Hardware'
// 方案->智慧门店
import PlanDetail from '@/view/PlanDetail'
// 方案->智慧影院
import PlanCinemaDetail from '@/view/PlanCinemaDetail'
// 方案->新零售
import PlanNewRetail from '@/view/PlanNewRetail'
// 方案->新餐饮
import PlanNewRestaurant from '@/view/PlanNewRestaurant'
// 方案=>智慧展厅
import PlanShowroom from '@/view/PlanShowroom'

import AboutShuoTuo from '@/view/AboutUs'
import Information from '@/view/Information'
import ProductPoster from '@/view/ProductPoster'
import UFOCatcher from '@/view/UFOCatcher'
import ProductMirror from '@/view/ProductMirror'
import ProductStorage from '@/view/ProductStorage'

// 产品->拼接屏
import ProductMPDP from '@/view/ProductMPDPTwo'
// 产品=>大转盘
import ProductBigWheel from '@/view/ProductBigWheel'
// 产品=>微笑领红包
import ProductSmile from '@/view/ProductSmile'

// 案例的海底捞详情
import SuccessCaseDetail from '@/view/SuccessCaseDetail'
// 案例的万达影城的详情
import CaseDetailWanDa from '@/view/CaseDetailWanDa'
// 案例的特步详情
import teBuCase from '@/view/teBuCase'
// 案例的小猪班纳
import CasePiglet from '@/view/CasePiglet'
import CaseNorthFace from '@/view/CaseNorthFace'
// 案例的GXG
import CaseGXG from '@/view/CaseGXG'
// 案例的Costa
import CaseCosta from '@/view/CaseCosta'
// 案例的热风
import CaseHotwind from '@/view/CaseHotwind'
// 案例的老乡鸡
import CaseFellowChicken from '@/view/CaseFellowChicken'
// 案例的泰禾影城
import CaseTaihe from '@/view/CaseTaihe'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "数拓科技SHOWTOP-AI+赋能 开启线下商显未来",
        content: '智能商显、智慧商显、屏幕、数拓、数拓科技、新零售、智慧门店、SHOWTOP、大屏幕',
        content1: '数拓科技官方网站为餐饮、3c、服装、零售等行业提供一站式智慧门店大屏幕解决方案，旗下囊括数字标牌、旺店大招牌、餐牌、云货架及新零售系列产品，同时提供商显内容制作、代运营、数拓客户服务及售后支持。'

      }
    },
    {
      path: '/Home',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "数拓科技SHOWTOP-AI+赋能 开启线下商显未来",
        content: '智能商显、智慧商显、屏幕、数拓、数拓科技、新零售、智慧门店、SHOWTOP、大屏幕',
        content1: '数拓科技官方网站为餐饮、3c、服装、零售等行业提供一站式智慧门店大屏幕解决方案，旗下囊括数字标牌、旺店大招牌、餐牌、云货架及新零售系列产品，同时提供商显内容制作、代运营、数拓客户服务及售后支持。'

      }
    },
    {
      path: '/Product',
      component: Product,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "产品 - 数拓SHOWTOP",
        content: '数拓产品、产品价格、产品功能',
        content1: '本页面提供数拓3大系列产品,包括商业显示基础产品、互动营销系列产品、新零售系列产品；包含产品海报机、旺店大招牌、云拼接、智能点播、娃娃机、大转盘、摇一摇、微笑领红包、星辰云货架、智能导购机、镜面试衣镜、入会机'
      },

    },
    // 产品->旺店
    {
      path: '/Product/ProductDetail',
      component: ProductDetail,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "旺店大招牌_数字餐牌 - 产品 - 数拓SHOWTOP",
        content: '旺店大招牌、数字餐牌',
        content1: '旺店大招牌是数拓专为餐饮行业打造的智慧化数字餐牌，它基于互联网云技术架构，可联可单，让餐牌变成引流大招牌。兼容叫号功能，提升餐牌价值。H5动态化展示，可编辑、快更新。定时播放机制，远程一键发布，让连锁品牌运营更高效。支持对接POS数据、会员数据，实现精准化营销'
      },
    },
    // 产品->海报
    {
      path: '/Product/ProductPoster',
      component: ProductPoster,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "海报机_液晶广告机 - 产品 - 数拓SHOWTOP",
        content: '海报机、广告机',
        content1: '数拓海报机可以将任意一块屏幕（液晶电视机、led、立式广告机、触摸屏等）都能变成专业的数字广告牌；与传统的广告信发系统不同，数拓海报机不是一台多媒体播放器，而是一台互联网智能终端；它能通过多端（手机、电脑、pad端）随时随地实时管理，一键下发内容'
      },
    },
    // 产品->拼接屏
    {
      path: '/Product/ProductMPDP',
      name: 'ProductMPDP',
      component: ProductMPDP
    },
    // 产品->娃娃机
    {
      path: '/Product/UFOCatcher',
      name: 'UFOCatcher',
      component: UFOCatcher
    },
    // 产品->试衣镜
    {
      path: '/Product/ProductMirror',
      name: 'ProductMirror',
      component: ProductMirror
    },
    // 产品->星辰云货架
    {
      path: '/Product/ProductStorage',
      name: 'ProductStorage',
      component: ProductStorage
    },
    // 产品->大转盘
    {
      path: '/Product/ProductBigWheel',
      name: 'ProductBigWheel',
      component: ProductBigWheel
    },
    // 产品->微笑领红包
    {
      path: '/Product/ProductSmile',
      name: 'ProductSmile',
      component: ProductSmile
    },
    
    // 成功案例
    {
      path: '/SuccessCases',
      name: 'SuccessCases',
      component: SuccessCases
    },
    // 成功案例->海底捞
    {
      path: '/SuccessCases/SuccessCaseDetail',
      name: 'SuccessCaseDetail',
      component: SuccessCaseDetail,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "海底捞 - 案例 - 数拓SHOWTOP",
        content: '海底捞、后厨直播、透明厨房、智能叫号、包间屏',
        content1: '餐饮行业案例-海底捞，数拓系统将海底捞门店内多样的硬件设备（PAD、大屏、广告机、迎宾屏等）统一化管理；另基于数拓平台的开放性，兼容了海底捞原有点餐、排号、叫号等平台，实现平台统一化运营；提供包括旺店大招牌、智能迎宾屏、后厨直播、智能叫号、包间屏等产品'
      },
    },
    {
      path: '/SuccessCases/teBuCase',
      name: 'teBuCase',
      component: teBuCase
    },
    // 成功案例->万达影城
    {
      path: '/SuccessCases/CaseDetailWanDa',
      name: 'CaseDetailWanDa',
      component: CaseDetailWanDa,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "万达院线 - 案例 - 数拓SHOWTOP",
        content: '万达、万达影城、万达院线',
        content1: '影城、院线行业案例-万达，数拓提供包括海报机、云拼接、超长联屏等产品，让万达从传统影厅进阶到数字化影厅；数拓系统是一个能够管理全国所有门店屏幕的平台，除此以外，数拓系统还具备开放的数据接口，让万达的票务信息能够实时的展示在屏幕上'
      },
    },
    // 成功案例=>The North Face
    {
      path: '/SuccessCases/CaseNorthFace',
      name: 'CaseNorthFace',
      component: CaseNorthFace
    },
    // 案例=>小猪班纳
    {
      path: '/SuccessCases/CasePiglet',
      name: 'CasePiglet',
      component: CasePiglet
    },
    // 案例=>GXG
    {
      path: '/SuccessCases/CaseGXG',
      name: 'CaseGXG',
      component: CaseGXG
    },
    // 案例=>costa
    {
      path: '/SuccessCases/CaseCosta',
      name: 'CaseCosta',
      component: CaseCosta
    },
    // 案例=>hotwind
    {
      path: '/SuccessCases/CaseHotwind',
      name: 'CaseHotwind',
      component: CaseHotwind
    },
    // 案例=>老乡鸡
    {
      path: '/SuccessCases/CaseFellowChicken',
      name: 'CaseFellowChicken',
      component: CaseFellowChicken
    },
     // 案例=>泰禾影城
     {
      path: '/SuccessCases/CaseTaihe',
      name: 'CaseTaihe',
      component: CaseTaihe
    },
    // 硬件
    {
      path: '/Hardware',
      name: 'Hardware',
      component: Hardware,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "硬件_V5,V8盒子,一体机 ,商业电视,综合传感器- 数拓SHOWTOP",
        content: 'V5盒子、V8盒子、商业电视、一体机、综合传感器、拼接屏、显示单元',
        content1: '数拓为商家提供V5盒子、V8盒子、商业显示电视、数拓一体机、智慧屏幕、综合传感器、8mm拼接屏、拼接单元等硬件设备'
      },
    },
     // 方案
     {
      path: '/Plan',
      name: 'Plan',
      component: Plan,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "行业解决方案 - 数拓SHOWTOP",
        content: '行业解决方案、智能商业显示解决方案、大屏幕解决方案、智慧门店解决方案',
        content1: '数拓面向餐饮、3c、新零售、服装等行业提供一站式智能商业屏幕解决方案，旨在以客户为中心，提供分享、极致、高效、舒心的行业升级改造方案，使商家能够快速调整或升级营销策略，加强品牌认知，带来更多利润'
      },
    },
    // 方案->智慧门店
    {
      path: '/Plan/PlanDetail',
      name: 'PlanDetail',
      component: PlanDetail,
      meta: {
        name: 'keywords',
        name1: 'description',
        title: "智慧门店 - 服装服饰新零售 - 行业解决方案 - 数拓SHOWTOP",
        content: '新零售、智慧门店、服装店解决方案、新零售智慧门店、服装智慧门店',
        content1: '数拓面向线下服装、服饰（衣服、鞋包、饰品等）行业提供互联互通的新零售智慧门店升级改造解决方案；满足零售各类店铺经营管理需求，吸引潜客入店、提升管理效率、提升顾客消费体验、拓展门店sku、转化新会员，同时可为门店营销策略的制定提供数据支持。'
      },
    },
    // 方案->智慧影院
    {
      path: '/Plan/PlanCinemaDetail',
      name: 'PlanCinemaDetail',
      component: PlanCinemaDetail
    },
    // 方案->新零售
    {
      path: '/Plan/PlanNewRetail',
      name: 'PlanNewRetail',
      component: PlanNewRetail
    },
    // 方案->新餐饮
    {
      path: '/Plan/PlanNewRestaurant',
      name: 'PlanNewRestaurant',
      component: PlanNewRestaurant
    },
    
    // 方案=>智慧展厅
    {
      path: '/Plan/PlanShowroom',
      name: 'PlanShowroom',
      component: PlanShowroom
    },
    {
      path: '/AboutShuoTuo',
      name: 'AboutShuoTuo',
      component: AboutShuoTuo
    },
    {
      path: '/Information',
      name: 'Information',
      component: Information
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js